<template>
  <div id="app">
    <router-view :key="key"></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  watch: {
    $route: function(to, from) {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  },

  computed: {
    key() {
      return this.$route.path + Math.random();
    }
  },
  methods: {
    // 添加判断方法
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    }
  },
  mounted() {
    if (this.isMobile()) {
      if (this.$cookies.get("isPc_H5") == null) {
        this.$confirm(
          "检测到您的设备为移动设备，是否跳转至H5版页面？",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
          .then(() => {
            window.location.href = "http://caselib.drcnet.com.cn/h5/";
            this.$cookies.set("isPc_H5", "h5", "3d");
          })
          .catch(() => {
            this.$cookies.set("isPc_H5", "pc", "3d");
          });
      } else if (this.$cookies.get("isPc_H5") == "h5") {
        window.location.href = "http://caselib.drcnet.com.cn/h5/";
      }
    }
  }
};
</script>

<style>
html,
body {
  width: 100%;
  height: 100%;
  background: rgb(240, 242, 247);
}

#app {
  width: 100%;
  background: #ffffff;
  /*height: 100%;*/
}
a {
  text-decoration: none;
  color: #000;
}
em {
  color: red;
  font-style: normal;
}
.notDocs {
  width: 100%;
  height: 525px;
  text-align: center;
  line-height: 200px;
  font-size: 30px;
  color: #ccc;
  font-weight: 800;
}
button {
  outline: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.el-message-box {
  position: fixed;
  top: 0;
  left: 0;
}
/* 字体 */
@import "./fonts/font.css";
</style>



// WEBPACK FOOTER //
// App.vue?96520f24